import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { installContactLinkTracking } from "../lib/analytics";

const GA_ID = "G-Q5N54EK3EB";

/**
 * Sends a GA4 page_view on every client-side route change.
 * The initial page load is already recorded by the gtag snippet in index.html,
 * so the first path is skipped. Tracking the last-sent path (rather than a
 * boolean) also makes this safe under React StrictMode's double effects.
 */
export default function Analytics() {
  const { pathname, search } = useLocation();
  const lastPath = useRef(null);

  // Every wa.me / tel: link on the site reports a whatsapp_click / phone_click.
  useEffect(() => installContactLinkTracking(), []);

  useEffect(() => {
    const path = pathname + search;
    if (lastPath.current === null) {
      lastPath.current = path; // initial load: gtag config already sent page_view
      return;
    }
    if (lastPath.current === path) return; // StrictMode re-run or no-op update
    lastPath.current = path;
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [pathname, search]);

  return null;
}
